import React, {Fragment} from 'react'
import Header from '../components/Header'
import Hero from '../components/Junior/Hero'
import VideoSection from '../components/Junior/VideoSection'
import Quiz from '../components/Junior/Quiz'
import Content from '../components/Junior/Content'
import CTA from '../components/Junior/CTA'
import Footer from '../components/Footer'
import {Link} from 'gatsby'


class Junior extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            device: 'desktop',
        }
    }
    
    render(){
        return(
            <Fragment>
                <Header logoColor="#32e2b9" classStatic="juniorHeader" dropDownColor="black" page='senior'  title="Albert"/>
                <Hero />
                <VideoSection />
                <Quiz />
                <Content />
                <CTA />
                <Footer />
            </Fragment>
        )
    }
}

export default Junior;